import useAvailableLines from '../../shared/hooks/useAvailableLines'
import { CustomLayout } from '../../../chart-kit/shared/utils/chartModel'
import { useMemo } from 'react'
import { useTypedSelector } from '../../../../State/RootReducer'
import {
  getBuildingConsumptionPreset,
  getDefaultDirectConsumptionPreset,
  getInitialPerformanceValueChart,
  getDirectConsumptionProductionPreset,
  getInitialProductionPieChart,
  getInitialHouseConsumptionPieChart,
  getYearComparisonPreset,
} from '../utils/initial-chart-config'
import useCheckDynamicPowerPriceApplicability from 'src/Libs/dynamic-power-prices/hooks/use-check-dynamic-power-price-applicability'
import { DEFAULT_CHART_HEIGHT } from 'src/Libs/chart-kit'
import { useWallboxHardwareByStorage } from 'src/Libs/wallboxes/hooks'

/**
 * This hook provides default charts available to all users in general. Traces can vary depending on the user's installation.
 */
const useDefaultCharts = (): CustomLayout[] => {
  const availableLines = useAvailableLines()
  const { data: wallboxes } = useWallboxHardwareByStorage()
  const powermeters = useTypedSelector(store => store.storage.powermeterHardware)
  const storageId = useTypedSelector(store => store.storage.activeStorage)?.toString() || ''
  const { isDynamicPowerPriceLoading, isDynamicPowerPriceEnabled } = useCheckDynamicPowerPriceApplicability(storageId)

  return useMemo(() => {
    const _presets: CustomLayout[] = []
    _presets.push(getInitialProductionPieChart(DEFAULT_CHART_HEIGHT))
    _presets.push(getInitialHouseConsumptionPieChart(DEFAULT_CHART_HEIGHT, !isDynamicPowerPriceLoading && isDynamicPowerPriceEnabled))
    _presets.push(getInitialPerformanceValueChart(DEFAULT_CHART_HEIGHT, availableLines, wallboxes, powermeters))
    _presets.push(getDefaultDirectConsumptionPreset(DEFAULT_CHART_HEIGHT, powermeters, wallboxes))
    _presets.push(getDirectConsumptionProductionPreset(DEFAULT_CHART_HEIGHT))
    _presets.push(getBuildingConsumptionPreset(DEFAULT_CHART_HEIGHT))
    _presets.push(getYearComparisonPreset())

    return _presets
  }, [availableLines, powermeters, wallboxes, isDynamicPowerPriceLoading, isDynamicPowerPriceEnabled])
}

export default useDefaultCharts
